import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "room-search-header align-items-center" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "position-relative" }

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useFloating, autoUpdate, offset, flip, shift } from "@floating-ui/vue";


export default {
  __name: 'RoomSearchHeader',
  props: {
	searchQuery: {
		type: String,
		default: "",
	},
},
  emits: ["update:search"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Local state
const popoverOpen = ref(false);
const searchButton = ref(null);
const popoverEl = ref(null);
const searchInput = ref(null);
const localSearchQuery = ref(props.searchQuery || "");

// Debounce timer
let searchTimeout = null;

// Setup floating UI for popover
const { floatingStyles: popoverStyles } = useFloating(searchButton, popoverEl, {
	middleware: [offset({mainAxis: 10, crossAxis: -5}), flip(), shift({ padding: 5 })],
	whileElementsMounted: autoUpdate,
	placement: "right-start",
	strategy: "fixed",
});

// Computed
const isSearchActive = computed(() => {
	return localSearchQuery.value.length > 0;
});

// Methods
const togglePopover = () => {
	popoverOpen.value = !popoverOpen.value;

	// Focus input when opening
	if (popoverOpen.value) {
		// Use nextTick equivalent
		setTimeout(() => {
			if (searchInput.value) {
				searchInput.value.focus();
			}
		}, 50);
	}
};

const closePopover = () => {
	popoverOpen.value = false;
};

const handleSearchInput = () => {
	// Clear existing timeout
	if (searchTimeout) {
		clearTimeout(searchTimeout);
	}

	// Debounce the search with 300ms delay
	searchTimeout = setTimeout(() => {
		emit("update:search", localSearchQuery.value);
	}, 300);
};

const clearSearch = () => {
	localSearchQuery.value = "";
	emit("update:search", "");

	// Keep popover open and focus input
	if (searchInput.value) {
		searchInput.value.focus();
	}
};

// Close popover when clicking outside
const handleClickOutside = (event) => {
	if (
		popoverOpen.value &&
		popoverEl.value &&
		searchButton.value &&
		!popoverEl.value.contains(event.target) &&
		!searchButton.value.contains(event.target)
	) {
		closePopover();
	}
};

// Watch for external changes to search query (e.g., filter reset)
watch(
	() => props.searchQuery,
	(newQuery) => {
		if (newQuery !== localSearchQuery.value) {
			localSearchQuery.value = newQuery || "";
		}
	}
);

// Lifecycle hooks
onMounted(() => {
	document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
	document.removeEventListener("click", handleClickOutside);
	if (searchTimeout) {
		clearTimeout(searchTimeout);
	}
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      ref_key: "searchButton",
      ref: searchButton
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createCommentVNode(" \"Räume\" Label "),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fw-bold" }, "Räume", -1 /* CACHED */)),
        _createCommentVNode(" Search Icon "),
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm ms-1",
          title: isSearchActive.value ? 'Suche aktiv' : 'Räume durchsuchen',
          onClick: togglePopover
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["fas fa-search search-icon", { active: isSearchActive.value }])
          }, null, 2 /* CLASS */)
        ], 8 /* PROPS */, _hoisted_2)
      ])
    ], 512 /* NEED_PATCH */),
    _createCommentVNode(" Search Popover (teleported to body to avoid calendar clipping) "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (popoverOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "popoverEl",
            ref: popoverEl,
            style: _normalizeStyle([_unref(popoverStyles), {"z-index":"2000","min-width":"250px","position":"fixed"}]),
            class: "popover-content bg-white border shadow-sm rounded p-3"
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
              _createElementVNode("h6", { class: "mb-0 fw-bold" }, " Räume durchsuchen ")
            ], -1 /* CACHED */)),
            _createCommentVNode(" Search Input "),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "searchInput",
                ref: searchInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((localSearchQuery).value = $event)),
                type: "text",
                class: "form-control form-control-sm",
                placeholder: "Raumnummer oder Name...",
                onInput: handleSearchInput,
                onKeydown: [
                  _withKeys(closePopover, ["esc"]),
                  _withKeys(closePopover, ["enter"])
                ]
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, localSearchQuery.value]
              ]),
              _createCommentVNode(" Clear button "),
              (localSearchQuery.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "position-absolute top-50 end-0 translate-middle-y me-2 btn btn-sm",
                    style: {"border":"none","background":"none","padding":"0.25rem"},
                    onClick: clearSearch
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fas fa-times text-muted" }, null, -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true)
            ])
          ], 4 /* STYLE */))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

}